jQuery(document).ready(function ($) {
    var windowWidth = $(window).outerWidth();
    // Hero Swiper
    var swiper = new Swiper('.hero-block--images', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
    });

    // Puffs slider
    var puff = new Swiper('.puff-section', {
        grabCursor: true,
        slidesPerView: 'auto',
        slidesOffsetBefore: 0,
        keyboard: {
            enabled: true
        },
        breakpoints: {
            320: {
              slidesOffsetBefore: 25,
            },
            1199: {
              slidesOffsetBefore: 0,
            },
        },
    });

    // Puff slider on mobile only
        var puffMobile = new Swiper('.puff-section-mobile', {
            grabCursor: true,
            slidesPerView: 'auto',
            slidesOffsetBefore: 0,
            keyboard: {
                enabled: true
            },
            breakpoints: {
              320: {
                slidesOffsetBefore: 25,
              },
              1199: {
                slidesOffsetBefore: 0,
              },
            },
        });

});
